const country = state => state.country;
const account = state => state.account;

export default {
    country,
    account
};
